import { faArrowRightToBracket } from "@fortawesome/pro-solid-svg-icons/faArrowRightToBracket";
import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  AuthFormContainer,
  type CommonAuthFormProps,
} from "@/components/auth-form-container";
import { SMSCodeInput } from "@/components/sms-code-input";

interface VerifyPhoneFormProps extends CommonAuthFormProps {
  isFirstTimeMFASetup: boolean;
  onChange: (code: string) => void;
  phoneNumberLastTwo: string;
}

export const VerifyPhoneForm = ({
  errorMessage,
  isFirstTimeMFASetup,
  onChange,
  onSubmit,
  phoneNumberLastTwo,
}: VerifyPhoneFormProps) => {
  return (
    <AuthFormContainer
      errorMessage={errorMessage}
      onSubmit={onSubmit}
      submitButtonContent={
        isFirstTimeMFASetup ? "Verify phone number" : "Log in"
      }
      submitButtonProps={{
        rightSection: (
          <FontAwesomeIcon
            icon={isFirstTimeMFASetup ? faCheck : faArrowRightToBracket}
          />
        ),
      }}
      subTitle={`Enter the code we sent to your phone number ending in **${phoneNumberLastTwo}.`}
      title="Verify phone number"
    >
      <SMSCodeInput onChange={onChange} />
    </AuthFormContainer>
  );
};
